/*
import { ContactService } from '../service/contact';
const cs = new ContactService();
const _init=async()=>{
    console.log(await ob.getContact({user_id:0}));
};
*/

import { API_ROUTE_CONTROLLER,API_VERBS } from "./route";
import { BaseService } from "./base";
import Cookies from 'universal-cookie';
import { API_HOST } from "../config";

const cookies = new Cookies();

export class InvoiceService extends BaseService {


    getLocations = async()=>{
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.Urgetmyaccuserlocation));
    };
    invoiceCommonService = async(url,_body)=>{
        return await this.getResponse(await this.post(url,_body));
    };


}
